export enum HalfHourType {
  HALF = '30 min',
  HOUR = '1 hour',
}

export const HALF_HOUR_OPTIONS = [
  {
    label: HalfHourType.HOUR,
    value: HalfHourType.HOUR,
  },
  {
    label: '1 hour',
    value: false,
  },
];

export type CellCoordinates = {
  dayIndex: number;
  dayCellIndex: number;
  span?: number;
};

/**
 * "from-to" time range defined as a pair of offsets from the `START_HOUR` measured as number of `CELL_DURATION`s.
 * E.g. if time range is 10:00 - 12:00, pair of offsets would be
 * (10:00 - 08:00 (START_HOUR)) = 120 minutes / 30 (CELL_DURATION) => fromOffset: 4
 * (12:00 - 08:00) = 240 minutes / 30 = 8 => toOffset: 8
 */
export type TimeRange = {
  fromOffset: number;
  toOffset: number;
};
